"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var utilities_1 = require("../../utilities");
var ButtomComponent_1 = __importDefault(require("../Form/ButtomComponent"));
var StepperComponent = function (_a) {
    var steps = _a.steps, stepCompletes = _a.stepCompletes, handleCompleted = _a.handleCompleted, _b = _a.activeStep, acStep = _b === void 0 ? 0 : _b, _c = _a.notBackButton, notBackButton = _c === void 0 ? false : _c;
    var _d = react_1.default.useState(acStep), activeStep = _d[0], setActiveStep = _d[1];
    var _e = react_1.default.useState(new Set()), skipped = _e[0], setSkipped = _e[1];
    var handleNext = function () {
        var newSkipped = skipped;
        setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
        setSkipped(newSkipped);
    };
    var handleBack = function () {
        setActiveStep(function (prevActiveStep) { return prevActiveStep - 1; });
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Stepper, __assign({ activeStep: activeStep }, { children: steps.map(function (step) {
                    return ((0, jsx_runtime_1.jsx)(material_1.Step, { children: (0, jsx_runtime_1.jsx)(material_1.StepLabel, { children: step.title }) }, step.title));
                }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                    paddingBlock: '30px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                } }, { children: steps.map(function (step, index) {
                    return activeStep === index ? ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: step.renderContent(index) }, index)) : null;
                }) })), (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        gap: '10px',
                        pt: 2,
                    } }, { children: [notBackButton === false && ((0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ variant: "outlined", disabled: activeStep === 0, onClick: handleBack, style: { textTransform: 'uppercase' } }, { children: "Regresar" }))), activeStep === steps.length - 1 ? ((0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", onClick: handleCompleted, disabled: !stepCompletes[steps.length - 1].isCompleted }, { children: "Completar" }))) : null, !(activeStep === steps.length - 1)
                            ? utilities_1.ArrayHelper.generateArray(stepCompletes.filter(function (_, index) { return index < steps.length - 1; })
                                .length).map(function (index) {
                                return activeStep === index && ((0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", onClick: handleNext, disabled: !stepCompletes[index].isCompleted }, { children: "Continuar" }), index));
                            })
                            : null] })) })] }));
};
exports.default = StepperComponent;
